import React, {useState, useEffect} from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './HomePageSlider.css';
import {Link, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import LoaderCustomFixed from "../ConfirmationModal/LoaderCustomFixed";

function HomePageSlider({slides, isLoading}) {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
    };


    const {t, i18n} = useTranslation();

    const [offsetY, setOffsetY] = useState(0);
    const handleScroll = () => setOffsetY(window.pageYOffset);
    const navigate = useNavigate()
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    if (isLoading) {
        return <LoaderCustomFixed/>;
    }

    return (
        <div className="slider-container">
            <Slider {...settings}>
                {slides.map((slide, index) => (
                    <div key={index} className="slider-slide" style={{transform: `translateY(-${offsetY * 0.1}px)`}}>
                        <div
                            className="slider-background-image"
                            style={{
                                backgroundImage: `linear-gradient(
                        195deg, 
                        rgba(0, 0, 0, 0.1) 1.54%,  
                        #000000 86.3%               
                    ), url(${slide.backgroundImage})`,
                                backgroundPositionY: offsetY * 0.5 + 'px',
                                backgroundSize: 'cover' // Ensures background covers entire area, adjust if needed
                            }}

                        ></div>
                        <div style={{position: 'relative', zIndex: 2}}>
                            <h1 className="slider-title">{i18n.language === 'geo' ? slide.title : slide.titleEng}</h1>
                            <p className="slider-description">{i18n.language === 'geo' ? slide.description : slide.descriptionEng}</p>
                                <button onClick={()=> window.open(slide.locationPath, "_blank")} className="slider-button">
                                    {i18n.language === 'geo' ? slide.buttonText : slide.buttonTextEng}
                                </button>
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
}

export default HomePageSlider;
